export const GET_ANALYTICS_INTENTS_REQ = 'GET_ANALYTICS_INTENTS_REQ';
export const GET_ANALYTICS_INTENTS_OK = 'GET_ANALYTICS_INTENTS_OK';

export const GET_ANALYTICS_REPORTS_REQ = 'GET_ANALYTICS_REPORTS_REQ';
export const GET_ANALYTICS_REPORTS_OK = 'GET_ANALYTICS_REPORTS_OK';

export const GET_DATA_BY_REPORT_REQ = 'GET_DATA_BY_REPORT_REQ';
export const GET_DATA_BY_REPORT_OK = 'GET_DATA_BY_REPORT_OK';
export const GET_PARTIAL_DATA_BY_REPORT_OK = 'GET_PARTIAL_DATA_BY_REPORT_OK';

export const ADD_ANALYTICS_REPORT_REQ = 'ADD_ANALYTICS_REPORT_REQ';
export const ADD_ANALYTICS_REPORT_OK = 'ADD_ANALYTICS_REPORT_OK';

export const RENAME_ANALYTICS_REPORT_REQ = 'RENAME_ANALYTICS_REPORT_REQ';
export const RENAME_ANALYTICS_REPORT_OK = 'RENAME_ANALYTICS_REPORT_OK';

export const DELETE_ANALYTICS_REPORT_REQ = 'DELETE_ANALYTICS_REPORT_REQ';
export const DELETE_ANALYTICS_REPORT_OK = 'DELETE_ANALYTICS_REPORT_OK';

export const ADD_ANALYTICS_REPORT_FILTER_REQ = 'ADD_ANALYTICS_REPORT_FILTER_REQ';
export const ADD_ANALYTICS_REPORT_FILTER_OK = 'ADD_ANALYTICS_REPORT_FILTER_OK ';

export const DELETE_ANALYTICS_REPORT_FILTER_REQ = 'DELETE_ANALYTICS_REPORT_FILTER_REQ';
export const DELETE_ANALYTICS_REPORT_FILTER_OK = 'DELETE_ANALYTICS_REPORT_FILTER_OK ';

export const CHANGE_ANALYTICS_PERIOD_REPORT_FILTER_REQ = 'CHANGE_ANALYTICS_PERIOD_REPORT_FILTER_REQ';
export const CHANGE_ANALYTICS_PERIOD_REPORT_FILTER_OK = 'CHANGE_ANALYTICS_PERIOD_REPORT_FILTER_OK ';

export const CHANGE_ANALYTICS_DATE_RANGE_REPORT_FILTER_REQ = 'CHANGE_ANALYTICS_DATE_RANGE_REPORT_FILTER_REQ';
export const CHANGE_ANALYTICS_DATE_RANGE_REPORT_FILTER_OK = 'CHANGE_ANALYTICS_DATE_RANGE_REPORT_FILTER_OK ';

export const TOGGLE_SHOW_EVENTS_FILTER_FOR_PATTERN_FLOW_REQ = 'TOGGLE_SHOW_EVENTS_FILTER_FOR_PATTERN_FLOW_REQ';
export const TOGGLE_SHOW_EVENTS_FILTER_FOR_PATTERN_FLOW_OK = 'TOGGLE_SHOW_EVENTS_FILTER_FOR_PATTERN_FLOW_OK';

export const UPDATE_INTENTS_IN_ANALYTICS_REPORT_REQ = 'UPDATE_INTENTS_IN_ANALYTICS_REPORT_REQ';
export const UPDATE_INTENTS_IN_ANALYTICS_REPORT_OK = 'UPDATE_INTENTS_IN_ANALYTICS_REPORT_OK';

export const UPDATE_PATTERNS_IN_ANALYTICS_REPORT_REQ = 'UPDATE_PATTERNS_IN_ANALYTICS_REPORT_REQ';
export const UPDATE_PATTERNS_IN_ANALYTICS_REPORT_OK = 'UPDATE_PATTERNS_IN_ANALYTICS_REPORT_OK';

export const RESET_ANALYTICS_REPORTS_DATA_REQ = 'RESET_ANALYTICS_REPORTS_DATA_REQ';
export const RESET_ANALYTICS_REPORTS_DATA_OK = 'RESET_ANALYTICS_REPORTS_DATA_OK';

export const TOGGLE_REPORT_SECTION_REQ = 'TOGGLE_REPORT_SECTION_REQ';
export const TOGGLE_REPORT_SECTION_OK = 'TOGGLE_REPORT_SECTION_OK';